import { action, makeAutoObservable } from "mobx";
import { ChatMsg } from "../models/api/ChatMsg";
import { ProgStatus } from "../models/utilTypes";
import { VChatRequest } from "../models/api/VChatRequest";
import { VNoteRequest } from "../models/api/vNote";
import ApiService from "../services/ApiService";
import { RecorderStore } from "./RecorderStore";
import * as Base64_Blob from 'base64-blob'
import { VChatMsg } from "../models/app/VChatMsg";
import moment from "moment";
import { CHAT_DATE_FORMAT, CHAT_TIME_FORMAT } from "../models/constants";
import { rootStore } from "../StApp";

export default class VChatDirectStore{

    chatId: string
    chatMsgList: VChatMsg[] = []
    prog: ProgStatus = 'INIT'
    recorderStore: RecorderStore

    //Current chat being prep
    currChatText: string = ''

    constructor(chatId: string, recorderStore: RecorderStore){
        makeAutoObservable(this, {
            recorderStore: false,
        })
        this.chatId = chatId
        this.recorderStore = recorderStore
    }

    @action
    loadVChats(){
        this.prog = 'LOADING'

        ApiService.getChatById({
            auth: rootStore.mainStore.token,
            data:{
                chatId: this.chatId,
                uid: rootStore.mainStore.uid!,
                userId: rootStore.mainStore.userName
            }
        }).then(resp=>{
            this.prog = 'SUCCESS'
            this.chatMsgList = resp.data.chatmsgList.map(item =>({
                ...item,
                timeOfSending: moment(item.time).format(CHAT_TIME_FORMAT),
                dateOfSending: moment(item.time).format(CHAT_DATE_FORMAT)
            }))
        })

    }

    @action
    recordVoice(){
        this.recorderStore.recordSound()
    }

    @action
    stopRecording(){
        this.recorderStore.stopRecording()
    }

    updateCurrText(chatText: string){
        this.currChatText = chatText
    }

    async sendVChat(){

        const blobData = await Base64_Blob.blobToBase64(this.recorderStore.blob!)
        let time = Date.now()
        let voice = blobData.split(',')[1]
        let vChatReq: VChatRequest = {
            chatId: this.chatId,
            msg: this.currChatText,
            time: time,
            uid: rootStore.mainStore.uid!,
            vNote: voice

        }

        let chatMsg: ChatMsg = {
            msg: this.currChatText,
            msgId: 'Pending'+Date.now(),
            senderUid: rootStore.mainStore.uid!,
            senderUserId: rootStore.mainStore.userName,
            time: time,
            voiceLocalUrl: this.recorderStore.srcUrl
        }

        let vChatMsg : VChatMsg = {...chatMsg, 
            timeOfSending: moment(time, 'x').format(CHAT_TIME_FORMAT),
            dateOfSending: moment(time, 'x').format(CHAT_DATE_FORMAT) 
        }

        this.chatMsgList = [...this.chatMsgList, vChatMsg ]

        ApiService.sendVChat({
            auth: rootStore.mainStore.token,
            data: vChatReq
        }).then(resp=>{

            vChatMsg.msgId = resp.data
            this.recorderStore.blob = null
            this.recorderStore.recordState = 'init'
            this.recorderStore.recordTimer = 0

        }).catch(err=> console.error(err))

    }

}